import React from 'react';
import PropTypes from 'prop-types';
import { MILLISECONDS_PER_DAY } from '@studio/conditions';
import { format } from 'next/lib/date';
import { ConditionText } from './styled';

export const EventCondition = ({
  event,
  operator,
  value,
  times = 1,
  negated,
}) => {
  const numOfDays = Math.ceil(value / MILLISECONDS_PER_DAY);
  return (
    <ConditionText>
      event {event} has {negated ? 'not' : ''} occurred at least {times} time
      {times > 1 ? 's' : ''}{' '}
      {operator === '< ago' &&
        `in the last ${numOfDays} day${numOfDays > 1 ? 's' : ''}`}
      {operator === 'since' && `since ${format(value, 'ddd MMM D YYYY')}`}
    </ConditionText>
  );
};

EventCondition.propTypes = {
  event: PropTypes.string.isRequired,
  operator: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  times: PropTypes.number.isRequired,
  negated: PropTypes.bool,
};
